<template>
<el-dialog class="editDialog" title="驳回" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" @close="cancel">
  <template v-if="visible">
    <section>
      <el-form ref="form1" :model="form1" :rules="rule">
        <el-form-item label="隐患等级：" prop="riskLevel">
          <el-select class="darkSelect" :popper-append-to-body="false" v-model="form1.riskLevel" filterable default-first-option placeholder="请选择" style="width:auto;" @change="yhdjChange">
            <el-option v-for="item in yhdj" :key="item.label" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注信息：" prop="remark">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form1.remark" maxlength="150">
          </el-input>
        </el-form-item>

      </el-form>
    </section>

    <div slot="footer" class="dialog-footer">

      <el-button class="cancelButton" type="primary" @click="cancel">取消</el-button>
      <el-button class="confirmButton" type="primary" @click="submit">保存</el-button>
    </div>
  </template>
</el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  descriptor,
  obj2urlsp
} from "utils"
export default {
  props: {
    row: {

    },
    pVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      form1: {
        status: 4,

      },
      visible: false
    }
  },
  components: {
    searchCompany: () => import("public/searchCompany")
  },
  computed: {
    ...mapGetters("Dictionary", ["yhdj"]),
    rule() {
      let that = this;
      return {
        riskLevel: descriptor(new Map([
          [true, "请选择隐患等级"]
        ]), "blur")
      }
    }
  },
  methods: {
    resetForm() {
      this.form1 = {
        status: 4,
      };
    },
    yhdjChange() {

    },
    submit() {
      this.$refs['form1'].validate(valid => {
        if (valid) {
          this.$axiospost('/operation/risk/update_status', obj2urlsp({
            ...this.form1,
            id: this.row.id,
            userAccount: localStorage.userAccount
          })).then(res => {
            this.$message({
              showClose: true,
              message: '驳回成功',
              type: 'success'
            });
            this.$emit('cancel');
          })
        }
      })
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  mounted() {},
  watch: {
    pVisible(n) {
      this.visible = n;
      if (n) {
        this.resetForm();
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/yinhuan/mine/more/bohui.vue